var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 29,
    viewBox: "0 0 200 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8687 6.9751V0.613243C10.0392 0.613243 6.57184 2.15956 4.0621 4.65947L8.57815 9.15727C9.93167 7.80914 11.8024 6.9751 13.8687 6.9751Z",
    fill: "#1965E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57835 9.15759L4.06231 4.65979C1.55257 7.15971 0 10.6132 0 14.4276H6.38707C6.38707 12.3694 7.22453 10.5061 8.57835 9.15759Z",
    fill: "#613DC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38707 14.4276H0C0 18.2416 1.55257 21.6952 4.06231 24.1951L8.57835 19.6969C7.22453 18.3488 6.38707 16.4855 6.38707 14.4276Z",
    fill: "#411655"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57815 19.6967L4.0621 24.1949C6.57184 26.6948 10.0392 28.2411 13.8687 28.2411V21.8793C11.8024 21.8793 9.93167 21.0452 8.57815 19.6967Z",
    fill: "#A0163A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8689 21.8792V28.2411C17.698 28.2411 21.1654 26.6948 23.6753 24.1949L19.1596 19.6967C17.8057 21.0452 15.9353 21.8792 13.8689 21.8792Z",
    fill: "#E52053"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1597 19.697L23.6755 24.1951C26.1852 21.6952 27.7379 18.2417 27.7379 14.4276H21.3507C21.3507 16.4855 20.5134 18.3488 19.1597 19.697Z",
    fill: "#EF6467"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8252 1.52196H22.263V6.06619H26.8252V1.52196Z",
    fill: "#1965E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8252 1.52196H22.263V6.06619H26.8252V1.52196Z",
    stroke: "#1965E1",
    strokeWidth: 3.0439,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2078 14.1826C53.8447 11.8096 52.431 10.603 49.9678 10.603C46.2931 10.603 45.0821 14.3033 45.0821 17.3601C45.0821 20.3766 46.2528 23.9161 49.8466 23.9161C52.5522 23.9161 54.0463 22.267 54.41 19.6929H59.9419C59.1746 25.2032 55.4196 28.2197 49.887 28.2197C43.5876 28.2197 39.3476 23.7954 39.3476 17.5612C39.3476 11.0856 43.2242 6.29931 50.0082 6.29931C54.9346 6.29931 59.4977 8.87346 59.8207 14.1826H54.2078Z",
    fill: "#1965E1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3864 23.9161C76.3034 23.9161 77.4744 20.618 77.4744 17.2796C77.4744 13.9413 76.3034 10.603 72.3864 10.603C68.5099 10.603 67.3388 13.9413 67.3388 17.2796C67.3388 20.618 68.5099 23.9161 72.3864 23.9161ZM72.3864 6.29931C78.9685 6.29931 83.2085 10.6432 83.2085 17.2796C83.2085 23.8759 78.9685 28.2197 72.3864 28.2197C65.8447 28.2197 61.6048 23.8759 61.6048 17.2796C61.6048 10.6432 65.8447 6.29931 72.3864 6.29931Z",
    fill: "#1965E1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0752 6.86203H91.5267V9.75793H91.6478C93.1015 7.3849 95.6051 6.29893 98.028 6.29893C104.125 6.29893 105.66 9.71771 105.66 14.866V27.6562H99.9262V15.9117C99.9262 12.493 98.9567 10.8037 96.2512 10.8037C93.1419 10.8037 91.8097 12.5332 91.8097 16.7564V27.6562H86.0752V6.86203Z",
    fill: "#1965E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.326 6.86203H114.778V9.75793H114.899C116.353 7.3849 118.856 6.29893 121.279 6.29893C127.376 6.29893 128.911 9.71771 128.911 14.866V27.6562H123.177V15.9117C123.177 12.493 122.208 10.8037 119.502 10.8037C116.393 10.8037 115.061 12.5332 115.061 16.7564V27.6562H109.326V6.86203Z",
    fill: "#1965E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.581 15.0272C146.056 12.1313 144.804 10.6029 142.018 10.6029C138.303 10.6029 137.374 13.4184 137.253 15.0272H146.581ZM137.253 18.6471C137.414 22.3072 139.151 23.916 142.381 23.916C144.683 23.916 146.54 22.5083 146.904 21.2212H151.952C150.336 26.1684 146.904 28.2197 142.18 28.2197C135.597 28.2197 131.519 23.7149 131.519 17.2796C131.519 11.0453 135.839 6.29926 142.18 6.29926C149.286 6.29926 152.759 12.252 152.315 18.6471H137.253Z",
    fill: "#1965E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169 14.1826C168.637 11.8095 167.223 10.6029 164.76 10.6029C161.085 10.6029 159.874 14.3032 159.874 17.36C159.874 20.3766 161.045 23.916 164.639 23.916C167.344 23.916 168.839 22.267 169.202 19.6928H174.734C173.967 25.2031 170.211 28.2197 164.68 28.2197C158.38 28.2197 154.14 23.7954 154.14 17.5611C154.14 11.0855 158.016 6.29926 164.8 6.29926C169.727 6.29926 174.29 8.8734 174.613 14.1826H169Z",
    fill: "#1965E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.643 6.86227H188.843V10.6833H184.643V20.9798C184.643 22.9104 185.128 23.3931 187.066 23.3931C187.712 23.3931 188.318 23.3529 188.843 23.2322V27.6967C187.873 27.8576 186.622 27.8978 185.491 27.8978C181.937 27.8978 178.909 27.1336 178.909 22.9506V10.6833H175.436V6.86227H178.909V0.628027H184.643V6.86227Z",
    fill: "#1965E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198 22.3525H193.438V26.8967H198V22.3525Z",
    fill: "#1965E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198 22.3525H193.438V26.8967H198V22.3525Z",
    stroke: "#1965E1",
    strokeWidth: 3.0439,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectLogo);
export default __webpack_public_path__ + "static/media/connect-logo.ea1e093b8f1bd529fe87ed37c419dc05.svg";
export { ForwardRef as ReactComponent };